/** What the officer records so the stage review can test what each criterion asks (AA-01 fact-check, group G3). */
export default {
  replyPoints: {
    title: "The reply, point by point",
    hint: "Take each point the party makes and answer it: accepted, discounted with reasons, or met with a request for evidence. The check reads that every point is answered and that the answers reach the report.",
    point: "Point made by the party",
    pointAr: "Point in Arabic (optional)",
    answer: "The Department's answer",
    answers: { Accepted: "Accepted", Discounted: "Discounted", EvidenceRequested: "Evidence requested" },
    unanswered: "Not yet answered",
    reasons: "Reasons",
    reasonsAr: "Reasons in Arabic (optional)",
    add: "Add a point",
    remove: "Remove",
    save: "Save the points",
    saved: "Points saved.",
    progress: "{{answered}} of {{total}} points answered",
    answeredBy: "Answered {{date}} by {{by}}",
    empty: "No point recorded yet. Split the reply into the points it makes.",
  },
  findings: {
    composed: "The Department's answer, as composed from the points (quoted in §4.6 of the report)",
  },
  reportReplies: {
    title: "Replies to the preliminary report",
    hint: "Replies received within the {{period.complaint.preliminaryReportReply}} working days are read and each point is addressed for the final report. They are not information requests.",
    party: "Party",
    partyOther: "Another party (name)",
    receivedAt: "Received on",
    summary: "What the reply says",
    record: "Record the reply",
    recorded: "Reply recorded.",
    none: "No reply recorded yet.",
    considered: "Considered {{date}} by {{by}}",
    late: "after the period",
  },
  classification: {
    title: "The Department's classification of the conduct",
    hint: "The Ministry is not bound by the complainant's characterisation (Regulations Article 23(4)): name the prohibited practice the facts map to, the article, and how the facts meet its elements.",
    complainant: "The complainant classifies it as {{conduct}} ({{articles}})",
    conduct: "Prohibited practice",
    articles: "Articles (comma-separated, e.g. 6, 8)",
    reasoning: "How the facts meet the elements of the article",
    reasoningAr: "Reasons in Arabic (optional)",
    save: "Record the classification",
    saved: "Classification recorded.",
    by: "Classified {{date}} by {{by}}",
  },
  standing: {
    title: "Complainant's standing and harm",
    hint: "A competitor, customer or supplier shows a legitimate interest; a consumer, harm to his interests (Article 32; complaints guidelines, Section 2.3). The harm is concrete when its kind is stated and it is quantified or dated.",
    relationship: "The complainant is the respondent's…",
    relationships: { Competitor: "Competitor", Customer: "Customer", Supplier: "Supplier", Distributor: "Distributor", Consumer: "Consumer", GovernmentEntity: "Government entity", Association: "Association", None: "No link stated" },
    activeInMarket: "Active in the market concerned",
    harmKind: "Kind of harm",
    estimatedHarm: "Estimated harm",
    harmKinds: { HigherPrices: "Higher prices", LostSales: "Lost sales", RefusalToSupply: "Refusal to supply", ExclusionFromMarket: "Exclusion from the market", DiscriminatoryTerms: "Discriminatory terms", ReducedChoiceOrQuality: "Reduced choice or quality", Other: "Other harm" },
    notStated: "Not stated",
    save: "Record standing and harm",
    saved: "Standing and harm recorded.",
  },
  contradiction: {
    status: { Open: "Open", Resolved: "Resolved", CarriedAsIssue: "Carried as an open issue" },
    resolve: "Resolve",
    carry: "Carry as an issue",
    note: "How it is resolved, or why it is carried",
    save: "Record",
    saved: "Contradiction decided.",
  },
  study: {
    conduct: "The suspected conduct",
    market: "The market concerned",
    harm: "The likely harm",
    elementsHint: "Each of the three is recorded on its own; the review checks all three before information is gathered.",
  },
  enforcement: {
    factsTitle: "Change of control and thresholds",
    controlEvidence: "What shows the change of control (clause of the transaction documents or the parties' reply)",
    thresholdTest: "Article 12 threshold met",
    thresholdTests: { Turnover: "Sales in the relevant market", Share: "Market share", Both: "Both" },
    registerTitle: "Register of economic concentrations",
    registerHint: "Check the register for a notification of this transaction before the outcome is recommended.",
    registerNone: "The register shows no notification",
    registerFound: "A notification is on the register",
    registerNote: "Note (optional)",
    registerRecord: "Record the register check",
    registerRecorded: "Register check recorded.",
    registerChecked: "Checked {{date}} by {{by}}: {{result}}",
  },
  remedies: {
    harm: "Harm of the report this commitment answers",
    harms: { HorizontalNonCoordinated: "Unilateral (non-coordinated) effects", HorizontalCoordinated: "Coordinated effects", Vertical: "Vertical foreclosure", Conglomerate: "Conglomerate effects", NonPrice: "Non-price effects" },
    harmReasoning: "Why it answers that harm in its market",
    chooseHarm: "The harm it answers",
    structural: "Why a structural remedy was not preferred",
    structuralHint: "Required when an accepted package has no structural commitment.",
    tieHint: "An accepted package ties each commitment, with reasons, to a harm the report identifies in the commitment's market.",
  },
  decision: {
    validUntil: "Valid until",
    validUntilHint: "A granted exemption states how long it is valid (Decree-Law Article 10(4)).",
  },
};
